<template>
  <div class="user-center">
    <div class="pull-left bgf" style="padding:20px 20px 20px 0;">
      <a class="title" :style="path=='/personal/wel'?'background-color: #f7dedd;color: red;':'color:#000'" @click="selMenu('/personal/wel')">首页</a>
      <dl class="user-center__nav" v-for="(item,index) in menus" :key="index">
        <div style="display: flex;align-items: center;">
          <dt>{{item.name}}</dt><span class="el-icon-arrow-down" style="margin-left: 5px;"></span>
        </div>
        <a v-for="(item2,index2) in item.items" :key="index+'_'+index2" @click="selMenu(item2.path)"><dd :class="path === item2.path?'active':''">{{item2.name}}</dd></a>
      </dl>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        path: '/personal/wel',
        menus: [
          {
            name: '账户信息',
            items: [
              {name:'个人资料',path:'/personal/userInfo'},
              {name:'资金管理',path:'/personal/fund'},
              // {name:'积分平台',path:'/personal/integral'},
              {name:'收货地址',path:'/personal/address'},
              // {name:'我的优惠券',path:'/personal/coupon'},
              // {name:'修改支付密码',path:'/personal/paypwdModify'},
              {name:'修改登录密码',path:'/personal/loginPwdModify'}
            ]
          },
          {
            name: '订单中心',
            items: [
              {name:'我的订单',path:'/personal/order'},
              {name:'我的收藏',path:'/personal/myCollect'},
              {name:'退款/退货',path:'/personal/refund'}
            ]
          },
          // {
          //   name: '服务中心',
          //   items: [
          //     {name:'物流查询',path:'/personal/logisticsQuery'},
          //     {name:'数据自助下载',path:'/personal/download'},
          //     {name:'售后服务',path:'/personal/saleService'},
          //     {name:'配送服务',path:'/personal/deliveryService'},
          //     {name:'用户协议',path:'/personal/userAgreement'},
          //     {name:'常见问题',path:'/personal/commonProblem'}
          //   ]
          // },
          // {
          //   name: '新手上路',
          //   items: [
          //     {name:'如何成为代理商',path:'/personal/newbie'},
          //     {name:'代销商上架教程',path:'/personal/listingTutorial'},
          //     {name:'分销商常见问题',path:'/personal/distributorCommonProblem'},
          //     {name:'付款账户',path:'/personal/paymentAccount'},
          //   ]
          // },
          // {
          //   name: 'U袋网',
          //   items: [
          //     {name:'企业简介',path:'/personal/companyProfile'},
          //     {name:'加入U袋',path:'/personal/addShow'},
          //     {name:'隐私说明',path:'/personal/privacyStatement'}
          //   ]
          // },
        ]
      };
    },
    mounted() {
      let that = this;
      setInterval(function(){
        let path = that.$router.currentRoute.path;
        if(path === '/order/detail' || path === '/personal/return' || path === '/personal/receipt'){
          that.path = '/personal/order';
        }else{
          that.path = path;
        }
      },300)
    },
    methods: {
      goIndex(name){
        if(name == '首页'){
          this.$router.push({path: '/home/index'})
        }
      },
      selMenu(path){
        this.path = path;
        this.$router.push({path: path});
      }
    }
  };
</script>

<style scoped>
  .user-center > .pull-left {
    width: 230px;
    font-size: 14px;
  }
  .pull-left {
    float: left !important;
  }
  .bgf {
    background-color: #fff;
  }
  body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, button, textarea, p, blockquote, th, td {
    margin: 0;
    padding: 0;
  }
  a{
    cursor: pointer;
  }
  .user-center > .pull-left .title {
    color: #fff;
    height: 32px;
    display: block;
    line-height: 32px;
    padding-left: 20px;
    /* margin-bottom: 10px; */
    text-decoration: none;
    /* background-color: #b31e22; */
  }
  .user-center__nav {
    color: #666;
    /* margin-bottom: 10px; */
  }
  dl {
    margin-top: 0;
    /* margin-bottom: 20px; */
  }
  .user-center__nav dt {
    /* background-color: #f5f5f5; */
  }

  .user-center__nav dt, .user-center__nav dd {
    line-height: 32px;
    padding-left: 20px;
  }
  dt {
    font-weight: bold;
  }
  .user-center__nav a {
    color: #666;
    text-decoration: none;
  }
  dd {
    margin-left: 16px;
  }
  .user-center__nav a:hover dd {
    /* background-color: #e0e0e0; */
  }
  .user-center__nav .active {
    background-color: #f7dedd;
    color: red;
    /* color: #FE7912; */
    /* padding-left: 16px; */
    /* border-left: 4px solid #FE7912; */
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/left_menu.vue